import { EventPackPage } from '@/features/events/routes/EventPackPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/tools/event-packs')({
  component: EventPackPage,
});
